interface IconProps {
  color?: string;
}

const BackIcon = ({ color = "#428BC1" }: IconProps) => {
  return (
    <svg
      width="12"
      height="24"
      viewBox="0 0 12 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.34299 12L10.414 19.071L8.99999 20.485L1.22199 12.707C1.03451 12.5195 0.929199 12.2652 0.929199 12C0.929199 11.7348 1.03451 11.4805 1.22199 11.293L8.99999 3.51501L10.414 4.92901L3.34299 12Z"
        fill={color}
      />
    </svg>
  );
};
export default BackIcon;
